// The probability models, and the registry a strategy names one by.
//
// A model is data plus two functions: `fit` turns history into a serialisable
// state, `predict` turns that state plus one match into a probability. Nothing
// else — no clock, no network, no storage — so a state fitted on the server
// this morning gives exactly the same numbers in a browser tonight.
//
// The contract itself is in ./base.js; see there for the Model shape and for
// `assertBefore`, the lookahead defence every `fit` calls.

import { marketConsensus } from './marketConsensus.js';
import { sharpAnchor } from './sharpAnchor.js';
import { elo } from './elo.js';
import { dixonColes } from './dixonColes.js';
import { closeLine } from './closeLine.js';
import { squiggleEnsemble } from './squiggleEnsemble.js';
import { cricketToss } from './cricketToss.js';
import { userUpload } from './userUpload.js';

export { LookaheadError, assertBefore, bindModel } from './base.js';

export const MODELS = {
  'market-consensus': marketConsensus,
  'sharp-anchor': sharpAnchor,
  elo,
  'dixon-coles': dixonColes,
  // The one model here that is not about who wins. See closeLine.js.
  'close-line': closeLine,
  'squiggle-ensemble': squiggleEnsemble,
  // Fitted on results, on purpose: the claim is not that it forecasts cricket
  // but that the toss is a fact the price may not carry. See cricketToss.js.
  'cricket-toss': cricketToss,
  'user-upload': userUpload,
};

/** A model by the id a strategy names in `probabilitySource.model`, or null. */
export function modelFor(id) {
  return MODELS[id] ?? null;
}

export { marketConsensus, sharpAnchor, elo, dixonColes, closeLine, squiggleEnsemble, cricketToss, userUpload };
